import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import {
    buildComponentListButtonStyleVars,
    buildComponentTypeListPath,
    getAvailableComponentListOptions,
    normalizeComponentListSettings,
    normalizeListComponentType,
} from '../utils/ComponentTypeLists';
import SpaceFollowButton from './SpaceFollowButton';
import './MuultiStyle.css';

export default function ComponentTypeListLinks({
                                                   components = [],
                                                   componentListSettings = {},
                                                   publicKey = '',
                                                   username = '',
                                                   currentType = '',
                                                   placement,
                                                   homePath = '',
                                                   homeLabel = 'Home',
                                                   showFollowButton = false,
                                                   showFollowerCount = false,
                                               }) {
    const normalizedSettings = useMemo(
        () => normalizeComponentListSettings(componentListSettings),
        [componentListSettings]
    );
    const availableOptions = useMemo(
        () => getAvailableComponentListOptions(components, normalizedSettings),
        [components, normalizedSettings]
    );
    const activeType = normalizeListComponentType(currentType);
    const renderPlacement = placement || normalizedSettings.placement || 'belowHeader';
    const alignment = normalizedSettings.alignment || 'center';
    const width = normalizedSettings.width || 'wide';
    const rowStyle = buildComponentListButtonStyleVars(normalizedSettings.buttonStyle);
    const safeHomePath = typeof homePath === 'string' ? homePath.trim() : '';
    const safeHomeLabel = typeof homeLabel === 'string' && homeLabel.trim() ? homeLabel.trim() : 'Home';

    if (!username && !safeHomePath) return null;

    return (
        <nav
            className={`component-type-list-links placement-${renderPlacement} align-${alignment} width-${width}`}
            aria-label="Component list pages"
            style={rowStyle}
        >
            {safeHomePath && (
                <Link
                    key="home"
                    className="component-type-list-link"
                    to={safeHomePath}
                >
                    {safeHomeLabel}
                </Link>
            )}
            {username && (
                <Link
                    className="component-type-list-link"
                    to={`/3d/space/${encodeURIComponent(username)}`}
                    title="Go to 3D space"
                >
                    3D Space
                </Link>
            )}
            {username && availableOptions.map((option) => (
                <Link
                    key={option.type}
                    className={`component-type-list-link${activeType === option.type ? ' is-active' : ''}`}
                    to={buildComponentTypeListPath({ publicKey, username, type: option.type })}
                    title={option.showCount === false
                        ? 'Go to social feed'
                        : `Go to ${option.listLabel.toLowerCase()} - ${option.count} ${option.pluralLabel.toLowerCase()}`}
                >
                    {option.listLabel}
                </Link>
            ))}
            {showFollowButton && publicKey ? (
                <SpaceFollowButton
                    targetPublicKey={publicKey}
                    targetMuultiName={username}
                    showFollowerCount={showFollowerCount}
                    className="component-type-list-follow"
                    compact
                />
            ) : null}
        </nav>
    );
}
